import { Flex, Heading, IconButton } from '@ghq-abi/design-system';
import { GridIcon } from '@ghq-abi/design-system-icons';
import { useTranslate } from '@tolgee/react';
import { useUser } from '~/shared/auth/useUser';
import { useEventsAnalytics } from '~/shared/hooks/useEvaluationAnalytics';
import { List } from '~/shared/components/icons';
import { COLORS } from '~/shared/constants';
import { useMyTickets } from '../context';
import type { ViewMode } from '../context/types';

interface ViewToggleButtonProps {
  mode: ViewMode;
  currentMode: ViewMode;
  icon: React.ReactNode;
  ariaLabel: string;
  onClick: () => void;
}

function ViewToggleButton({
  mode,
  currentMode,
  icon,
  ariaLabel,
  onClick,
}: ViewToggleButtonProps) {
  const isActive = currentMode === mode;

  return (
    <IconButton
      aria-label={ariaLabel}
      icon={icon}
      onClick={onClick}
      css={{
        backgroundColor: isActive
          ? `${COLORS.YELLOW_LIGHT} !important`
          : '$white !important',
        borderRadius: '4px',
        border: '1px solid #CACDD5',
        '&:focus': {
          backgroundColor: isActive
            ? `${COLORS.YELLOW_LIGHT} !important`
            : '$white !important',
        },
      }}
    />
  );
}

export function MyTicketsHeader() {
  const { viewMode, setViewMode } = useMyTickets();
  const { t } = useTranslate();
  const user = useUser();
  const eventsAnalytics = useEventsAnalytics();

  return (
    <Flex justify="between" align="center" css={{ marginBottom: '$4' }}>
      <Heading as="h1" size="lg">
        {t('my_tickets.title')}
      </Heading>

      <Flex css={{ gap: '$2' }}>
        <ViewToggleButton
          mode="list"
          currentMode={viewMode}
          icon={<List />}
          ariaLabel="List View"
          onClick={() => setViewMode('list')}
        />
        <ViewToggleButton
          mode="grid"
          currentMode={viewMode}
          icon={<GridIcon />}
          ariaLabel="Grid View"
          onClick={() => {
            setViewMode('grid');
            eventsAnalytics.fireClickCardsViewAnalyticsEvent(user);
          }}
        />
      </Flex>
    </Flex>
  );
}
